// extracted by mini-css-extract-plugin
module.exports = {"comp":"SectionA6_comp__LR1ei"};